// import { isApp, getUrlParams, session } from '@/plugs';
import { getSessionByWeb, getSession } from "./session";
import { getUrlParams, isApp } from "./index";

export default class Moba {
  constructor(options) {
    this.mounted = options.mounted;
    this.checkEnvironment(options);
  }

  checkEnvironment() {
    console.log(window.navigator.userAgent, isApp);
    if (isApp || getUrlParams().isApp) {
      this.execNativeInt();
    } else {
      this.execWebInit();
    }
  }

  execNativeInt() {
    console.log(isApp);
    if (isApp) {
      if (/Android/i.test(window.navigator.userAgent)) {
        console.log("Android");
        document.addEventListener("JsBridgeReady", () => {
          console.log("JsBridgeReady");
          getSession()
            .then(resp => this.mounted(resp))
            .catch(err => {
              throw new Error(err);
            });
        });
      } else {
        getSession()
          .then(resp => this.mounted(resp))
          .catch(err => {
            throw new Error(err);
          });
      }
    } else {
      getSessionByWeb()
        .then(resp => this.mounted(resp))
        .catch(err => {
          throw new Error(err);
        });
    }
  }

  execWebInit() {
    this.mounted();
  }
}
